import { ApiError } from './api';
import { MIN_PASSWORD_LENGTH } from './config';
import { t } from '@/i18n';

/**
 * Turn any thrown error into a user-facing, localized message.
 * Prefers a translated `error.<code>`; falls back to the server's English detail,
 * then a generic message. Never surfaces a raw stack.
 */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const key = `error.${err.code}`;
    const localized = t(key, { min: MIN_PASSWORD_LENGTH });
    if (localized !== key) return localized;
    return err.detail ?? t('common.genericError');
  }
  return t('common.genericError');
}
